export default __webpack_public_path__ + "static/media/contacts-tab.b49a2537.png";